import { useId } from "react";

import { cn } from "@/lib/utils";

export function BothIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-27.5 w-[277px]", className)}
      fill="none"
      preserveAspectRatio="xMinYMin slice"
      viewBox="0 0 277 110"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}a)`}>
        <rect fill="#fff" fillOpacity="0.1" height="110" rx="10" width="277" />
        <g clipPath={`url(#${id}b)`}>
          <path d="M-28 0h335v141H-28z" fill="#fff" />
          <path d="M-28 0h335v141H-28z" fill="#000" fillOpacity="0.2" />
          <g filter={`url(#${id}c)`}>
            <ellipse
              cx="35.161"
              cy="70.356"
              fill="#FF9877"
              rx="121.379"
              ry="121.356"
            />
          </g>
          <g filter={`url(#${id}d)`}>
            <ellipse
              cx="248.985"
              cy="70.356"
              fill="#31C7ED"
              rx="121.379"
              ry="121.356"
            />
          </g>
          <path
            d="M27.22 78.706C.035 17.276-70.525 74.828-39.214 105.04-67 185 268.092 133.949 386.476 153.677c13.752-3.588 19.764-36.213 2.845-48.888-16.918-12.676-31.006.155-41.206 6.253-1.614-7.814-15.303-8.106-21.946-7.275-2.416-39.612-42.935-34.765-47.599-8.43-4.895-9.6-15.605-6.403-20.347-3.604.292-13.5-13.034-15.985-19.733-15.54-10.143-63.96-81.394-43.646-78.219-4.82-4.501-10.132-21.868-.861-18.717 8.355-11.083-11.901-25.692-8.691-31.611-5.599 4.354-49.685-65.752-41.714-53.728 2.907-12.48-4.017-24.53-.56-28.996 1.67z"
            fill="#3FC7C0"
          />
          <path
            d="M214.314 126.385c31.982-4.1 28.783 15.821 23.185 26.294-113.089-7.931-219.963-31.526-259.264-42.333C-18.93 97.617-6.248 98.47-.262 100.487c-3.89-27.663 23.109-39.738 40.613-8.108 4.704-7.339 14.89-4.433 19.396-2.063 7.198-40.718 46.6-31.655 45.646-.908 13.335-5.638 22.506 1.579 25.425 5.892 10.322-9.137 27.819-5.718 31.523 8.964 26.836-31.577 52.945-9.203 39.876 10.517 12.152.218 13.128 7.827 12.097 11.604z"
            fill="#209F99"
          />
        </g>
        <path
          d="M176.672 78.055c-.836 1.57-3.064 4.484-5.292 3.566-1.531-.63.529-2.266 1.377-1.6"
          stroke="#413776"
          strokeLinecap="round"
          strokeWidth="1.212"
        />
        <path
          d="M200.481 55.927c-1.75-.634-3.616.884-4.33 1.722 0 .373.528.62.792.698.791-.837 2.607-1.536 2.607-.698 0 .67-.683 1.738-1.024 2.188l1.024.652c.978-.372 3.119-3.77.931-4.562z"
          fill="#413776"
        />
        <path
          d="M184.476 37.154c-6.769 2.184-6.233 19.171 5.502 15.227-8.379-2.027 6.654-5.932 3.776-14.291-2.878-8.36-6.002-8.352-8.459-9.261 1.638.819 7.643 5.595-.819 8.325z"
          fill={`url(#${id}e)`}
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M170.028 55.927c1.751-.634 3.616.884 4.33 1.722 0 .373-.528.62-.792.698-.791-.837-2.607-1.536-2.607-.698 0 .67.683 1.738 1.025 2.188l-1.025.652c-.977-.372-3.119-3.77-.931-4.562z"
          fill="#413776"
        />
        <path
          d="M192.055 53.959h-13.916l-1.52 2.225c-5.524 2.226-9.273 6.56-9.273 11.542 0 7.253 7.947 13.133 17.751 13.133 9.803 0 17.751-5.88 17.751-13.133 0-4.982-3.749-9.316-9.274-11.542l-1.519-2.225z"
          fill={`url(#${id}f)`}
        />
        <path
          d="M194.171 78.055c.835 1.57 3.063 4.484 5.292 3.566 1.531-.63-.529-2.266-1.377-1.6"
          stroke="#413776"
          strokeLinecap="round"
          strokeWidth="1.212"
        />
        <path
          d="M174.009 53.496a.909.909 0 01.885-1.114h20.405a.908.908 0 01.885 1.114l-.266 1.148a.91.91 0 01-.885.704h-19.872a.908.908 0 01-.885-.703l-.267-1.15z"
          fill="#413776"
        />
        <path
          clipRule="evenodd"
          d="M179.081 80.086c1.878.5 3.904.773 6.015.773 9.804 0 17.751-5.88 17.751-13.133 0-4.884-3.603-9.145-8.95-11.408 2.325 8.304.971 20.987-14.816 23.768z"
          fill="#413776"
          fillRule="evenodd"
        />
        <path
          d="M118.364 78.713c.139-.324 3.381-8.944 4.984-13.213l15.474-21.848 8.287 24.34c.483 3.593 1.483 10.977 1.622 11.765.174.985 6.433 2.434 7.244 2.55.812.115-3.245.81-4.288 1.1-1.043.29 4.23 1.855 4.984 2.435.753.58-9.562 4.172-17.096 5.447-7.534 1.275-12.866.696-16.227-.637-3.361-1.333-10.547-2.203-10.083-2.203.37 0 2.974-2.086 4.23-3.129-1.777.174-5.343.417-5.39 0-.057-.521 4.984-2.608 5.39-3.013.406-.406.695-3.188.869-3.594z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.068"
        />
        <path
          d="M128.529 18.869c-.998 2.217-.416 3.572 0 3.972-1.456 0-5.304.919-7.047 1.378l-3.546-1.098-.971 12.623c1.632.957 5.015 2.888 5.488 2.956.473.067 3.582-1.158 5.077-1.778.971 1.275.151 7.567-.38 10.554-2.303 5.163-6.879 15.702-6.758 16.552.152 1.063 12.756 11.39 13.288 10.934.425-.365 1.654-7.616 4.936-18.245l6.134 16.211c.881-.044 4.176-5.155 5.714-7.706l-3.526-7.425c.057-2.578-2.438-11.82-3.693-16.119.863.365 5.909 2.419 7.956 3.18 4.658-1.752 5.541-9.639 2.401-10.972-.885-.747-4.383-3.393-4.881-3.824-.622-.54-.995-.083-2.157-.996s-2.655-5.186-2.78-5.767c-.099-.465-1.55-1.05-2.263-1.285 1.381-1.34 1.381-2.05-.376-4.52-1.758-2.469-1.961-6.096-2.529-6.743-.454-.518-1.401-.39-1.818-.262-.763-.563-2.059-.643-2.611-.613-.531-.168-1.691-.548-2.08-.719-.485-.214-3.362.622-3.578 1.594-.173.777-1.52 2.749-2.171 3.638.37.591 1.232.03 1.617-.323-.185 1.662.292 3.895.554 4.803z"
          fill="#fff"
        />
        <path
          clipRule="evenodd"
          d="M117.14 35.848l.309-6.415.485-6.312 3.547 1.098c1.742-.46 5.591-1.378 7.046-1.378-.415-.4-.997-1.755 0-3.972-.261-.908-.739-3.14-.554-4.803-.385.354-1.247.914-1.616.323.651-.889 1.997-2.86 2.17-3.638.217-.972 3.093-1.807 3.579-1.594.389.171 1.548.551 2.08.72.552-.031 1.848.049 2.611.612.417-.128 1.363-.256 1.818.262.212.242.373.899.583 1.756.353 1.439.844 3.44 1.945 4.987.172.242.327.466.466.676l-.089.087c.058.02.12.04.187.064 1.174 1.825 1.026 2.517-.187 3.693.713.235 2.163.82 2.263 1.285.124.581 1.618 4.854 2.78 5.767.652.512 1.056.593 1.395.661.264.053.489.098.762.335.23.2 1.104.874 2.063 1.614 1.113.86 2.342 1.81 2.818 2.21 2.764 1.174 2.41 7.427-.892 10.101a399.9 399.9 0 01-5.708-2.309c.158.543.276 1.104.362 1.677a344.7 344.7 0 01-4.119-1.677c1.254 4.3 3.75 13.541 3.693 16.12l2.517 5.3c-1.667 2.638-3.988 6.037-4.705 6.073l-6.134-16.21c-1.962 6.35-3.19 11.496-3.951 14.686-.513 2.15-.814 3.411-.986 3.558-.45.386-9.555-6.958-12.428-9.864 1.417-3.673 4.244-10.156 5.899-13.865.265-1.493.603-3.813.753-5.919a.393.393 0 00.077-.164c.005-.05-.011-.102-.054-.175.122-1.968.063-3.693-.397-4.296-1.495.62-4.603 1.845-5.076 1.778-.457-.065-3.625-1.867-5.312-2.852z"
          fill={`url(#${id}g)`}
          fillRule="evenodd"
        />
        <path
          d="M136.798 25.688l1.867 31.27"
          stroke="#fff"
          strokeWidth="0.376"
        />
        <path
          clipRule="evenodd"
          d="M154.936 40.691c-4.128-1.003-10.159-3.733-12.353-5.76l.63 6.545.755.503c1.705.7 5.518 2.242 7.23 2.878 1.841-.692 3.092-2.341 3.738-4.166zm-28.686 8.811c4.073-4.72 2.25-27.151 2.25-22.97 0 3.36-3.579 10.198-6.056 12.133l-.042.024a.425.425 0 00.049.01c.473.068 3.582-1.156 5.077-1.777.972 1.275.151 7.567-.38 10.554-.272.609-.575 1.292-.898 2.026zm-7.449-12.697c1.896-4.69.538-11.2.077-13.39l-1.07 1.343-.845 10.987c.495.29 1.151.67 1.838 1.06z"
          fill="#17677C"
          fillRule="evenodd"
        />
        <path
          d="M158.137 19.93l1.452 4.863v1.891l-3.45 13.419-1.269 14.757v11.295l-3.365 17.532 1.377.841 3.257-18.373.735-9.92 2.598-5.04c-.04-.637-.195-1.91-.487-1.91-.293 0-1.529 2.15-2.111 3.225l.563-4.557v-4.277c.619-2.963 1.857-9.058 1.857-9.734 0-.675 1.656-5.12 2.485-7.258V23.85l1.117-2.57c1.45-1.186 4.381-3.678 4.508-4.16.128-.484-.238-.655-.437-.68l-3.266 1.448c0-.474 3.553-3.022 5.33-4.237.198-.501.565-1.54.456-1.686-.11-.146-3.903 1.974-5.786 3.053a802.271 802.271 0 00-2.461-2.187c-.291-.255-.911.774-1.184 1.32l.911 2.78-.911 3.736c-.156-.425-.583-1.349-1.048-1.64-.465-.292-.774.481-.871.904z"
          fill={`url(#${id}h)`}
        />
        <path
          d="M116.367 20.809l-1.792-1.48c-3.133-.353-4.786 7.712-4.973 11.41-.186 3.699 1.42 7.21 2.391 7.472.777.209 1.718-.536 2.092-.934l2.282.934c.609-1.021 1.992-3.728 2.649-6.388.658-2.66-.274-8.181-.822-10.61l-1.827-.404z"
          fill="#fff"
        />
        <path
          d="M158.228 33.727c-.426-.367-1.563-.153-2.078 0-.174.87.491 3.101.845 4.108.137.218.653.633 1.619.556 1.208-.097 1.909-4.301 1.619-4.663-.232-.29-1.434-.121-2.005 0z"
          fill="#4D0D54"
        />
        <path
          d="M115.453 28.81c.336-1.378-.308-6.51-.672-8.904-2.184 0-3.57 7.685-3.612 9.827-.042 2.142.294 6.93 1.176 6.93.882 0 2.688-6.132 3.108-7.854z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.068"
        />
        <path
          d="M153.164 32.31c-.274.03-.721.342-.911.494.721.948 2.094 3.437 1.821 5.805-.273 2.367-2.441 5.489-3.491 6.754.38.126 1.199.379 1.442.379.243 0 .86.48 1.139.72 2.162-.34 3.376-5.539 3.756-8.346.379-2.808-1.214-5.123-1.48-5.085-.265.038-1.935-.759-2.276-.72z"
          fill="#fff"
        />
        <path
          d="M111.067 17.87c.228 0 2.498 1.476 3.605 2.214 1.149.753 1.027 3.918.822 5.407l-3.352-4.712-1.676.823c-1.096-.074-3.371-.222-3.7-.222-.411 0-2.023-1.644-2.023-2.403 0-.759 1.265-.063 1.612 0 .279.05 1.676-.316 2.34-.506-1.77-.316-1.77-1.012-1.17-1.138.601-.127 3.257.537 3.542.537z"
          fill="#4D0D54"
        />
        <path
          d="M132.472 14.018c-2.219 2.546-3.588 7.325-2.774 8.287.422.498 4.05 2.393 6.918 1.775 2.661-.573 4.599-3.635 4.438-3.884-.266-.414-2.133-5.647-3.033-8.212-.925-.382-3.329-.51-5.549 2.034z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.068"
        />
        <path
          d="M132.139 24.608c-.405-2.48.393-5.046 2.449-6.832.949-.824 2.113-.621 3.151.019 2.312 1.425 2.515 4.489 2.926 7.173 1.341 8.75 5.976 8.805 8.557 14.017 2.932 5.92-1.711 9.398.79 11.953 2.5 2.554 4.031.808 4.877 0-.731 1.005-3.687 2.698-5.289 1.727-1.603-.972-2.013-1.333-2.013-7.478s-7.611-10.712-8.513-11.558c-.902-.846-6.427-5.92-6.935-9.02z"
          fill="#fff"
        />
        <g filter={`url(#${id}i)`}>
          <path
            d="M96.962 22.792c1.354 3.044 5.779 3.383 7.823 3.171 2.89-.564 8.796-2.283 9.303-4.651.634-2.96-2.114-4.652-3.911-5.392-1.797-.74-.952-2.325 1.797-3.488 2.748-1.163 4.018-2.565 2.114-5.92s-6.131-5.286-6.026-3.489c.106 1.797-2.22 4.335-4.017 3.489-1.797-.846-.634-2.749-.634-4.334 0-1.27-.564-2.291-.846-2.643.106 1.903-6.66 5.708-6.66 8.668 0 2.96 3.383 4.017 3.7 5.392.317 1.374-4.334.105-3.7 1.48.635 1.374-.634 3.911 1.057 7.717z"
            fill={`url(#${id}j)`}
            shapeRendering="crispEdges"
          />
        </g>
        <g filter={`url(#${id}k)`}>
          <path
            d="M113.455 15.92c1.268-.599 3.7-3.15 3.277-6.448.493 2.572.528 7.463-3.277 6.449z"
            fill="#2AF5C4"
          />
        </g>
        <path
          d="M130.5 74C2.094 74-102 118.772-102 174h465c0-55.228-104.094-100-232.5-100z"
          fill="#2B2C3F"
        />
        <g filter={`url(#${id}l)`}>
          <path
            clipRule="evenodd"
            d="M114.086 93.99c-.739-.577-1.294-1.21-1.6-1.752-.154-.271-.234-.499-.257-.67-.022-.168.014-.242.038-.273.023-.03.086-.083.256-.102.171-.02.411.002.712.086.599.166 1.348.55 2.087 1.126.739.576 1.293 1.21 1.6 1.751.154.272.233.499.256.67.023.169-.013.243-.037.273-.024.03-.087.084-.256.103-.171.019-.411-.003-.712-.086-.6-.166-1.349-.55-2.087-1.127zm-2.56-3.273c-.227.29-.273.645-.228.976.02.15.059.304.114.458l-.752 5.48a.51.51 0 00.688.544l5.254-2.032c.134.009.264.007.388-.007.332-.038.665-.168.892-.459.227-.29.272-.645.228-.976-.044-.329-.18-.673-.37-1.008-.381-.673-1.028-1.396-1.84-2.03-.811-.633-1.67-1.084-2.415-1.29-.371-.103-.738-.151-1.068-.114-.332.037-.665.168-.891.458z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            d="M113.343 91.617c.663-.565.926-1.188.869-2.06-.04-.605-.23-1.095-.577-1.481m3.041 5.727c.365-.792.893-1.213 1.746-1.39.485-.101.924-.084 1.322.055m-4.815.386l4.009-5.52"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="0.8"
          />
          <circle
            cx="110.492"
            cy="87.27"
            fill="#fff"
            r="0.583"
            transform="rotate(-15 110.492 87.27)"
          />
          <circle
            cx="120.604"
            cy="90.381"
            fill="#fff"
            r="0.583"
            transform="rotate(-15 120.604 90.381)"
          />
          <circle
            cx="121.381"
            cy="86.395"
            fill="#fff"
            r="0.583"
            transform="rotate(-15 121.381 86.395)"
          />
          <path
            d="M115.905 85.404c.008-.145.197-.196.276-.074l.297.458a.15.15 0 00.165.063l.527-.141a.15.15 0 01.155.24l-.343.424a.149.149 0 00-.009.176l.297.457a.15.15 0 01-.18.222l-.509-.195a.15.15 0 00-.171.045l-.343.425a.15.15 0 01-.267-.103l.029-.545a.15.15 0 00-.096-.148l-.51-.195a.15.15 0 01.015-.285l.528-.142a.152.152 0 00.111-.137l.028-.545zm4.135 8.341a.15.15 0 01.275-.074l.464.714a.15.15 0 00.165.063l.822-.22c.14-.037.246.127.155.24l-.536.66a.152.152 0 00-.009.177l.464.714a.15.15 0 01-.18.221l-.794-.304a.15.15 0 00-.171.045l-.535.662a.15.15 0 01-.267-.103l.045-.85a.151.151 0 00-.096-.147l-.795-.306a.15.15 0 01.015-.284l.822-.22a.15.15 0 00.111-.138l.045-.85zm18.767-1.473c.63.117 1.147.432 1.552.944.406.512.608 1.099.608 1.76 0 .597-.149 1.125-.448 1.584-.288.448-.709.8-1.264 1.056-.554.256-1.21.384-1.968.384h-4.816V86.832h4.608c.758 0 1.408.123 1.952.368.555.245.971.587 1.248 1.024.288.437.432.933.432 1.488 0 .65-.176 1.195-.528 1.632-.341.437-.8.747-1.376.928zm-4.096-.832h2.048c.534 0 .944-.117 1.232-.352.288-.245.432-.592.432-1.04 0-.448-.144-.795-.432-1.04-.288-.245-.698-.368-1.232-.368h-2.048v2.8zm2.256 4.736c.544 0 .966-.128 1.264-.384.31-.256.464-.619.464-1.088 0-.48-.16-.853-.48-1.12-.32-.277-.752-.416-1.296-.416h-2.208v3.008h2.256zm9.721 1.968c-.853 0-1.621-.187-2.304-.56a4.208 4.208 0 01-1.616-1.616c-.384-.693-.576-1.493-.576-2.4 0-.907.198-1.707.592-2.4a4.175 4.175 0 011.648-1.6c.694-.384 1.467-.576 2.32-.576.854 0 1.627.192 2.32.576a4.053 4.053 0 011.632 1.6c.406.693.608 1.493.608 2.4 0 .907-.208 1.707-.624 2.4a4.25 4.25 0 01-1.664 1.616c-.693.373-1.472.56-2.336.56zm0-1.952c.406 0 .784-.096 1.136-.288.363-.203.651-.501.864-.896.214-.395.32-.875.32-1.44 0-.843-.224-1.488-.672-1.936a2.144 2.144 0 00-1.616-.688c-.64 0-1.178.23-1.616.688-.426.448-.64 1.093-.64 1.936s.208 1.493.624 1.952c.427.448.96.672 1.6.672zm8.876-5.216v4.288c0 .299.069.517.208.656.149.128.394.192.736.192h1.04V98h-1.408c-1.888 0-2.832-.917-2.832-2.752v-4.272h-1.056v-1.84h1.056v-2.192h2.256v2.192h1.984v1.84h-1.984zm8.587-1.968c.672 0 1.269.15 1.792.448.522.288.928.72 1.216 1.296.298.565.448 1.248.448 2.048V98h-2.24v-4.896c0-.704-.176-1.243-.528-1.616-.352-.384-.832-.576-1.44-.576-.619 0-1.11.192-1.472.576-.352.373-.528.912-.528 1.616V98h-2.24V86.16h2.24v4.08a2.856 2.856 0 011.152-.896 3.736 3.736 0 011.6-.336z"
            fill="#fff"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}e`}
          x1="186.323"
          x2="186.323"
          y1="34.093"
          y2="52.381"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}f`}
          x1="185.097"
          x2="185.097"
          y1="53.959"
          y2="80.859"
        >
          <stop stopColor="#7785F1" />
          <stop offset="1" stopColor="#413776" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}g`}
          x1="136.297"
          x2="136.297"
          y1="9.124"
          y2="68.322"
        >
          <stop stopColor="#2891C5" />
          <stop offset="1" stopColor="#166576" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}h`}
          x1="160.506"
          x2="160.506"
          y1="11.957"
          y2="84.528"
        >
          <stop stopColor="#AE6328" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}j`}
          x1="105.421"
          x2="105.421"
          y1="10.021"
          y2="36.937"
        >
          <stop stopColor="#2AF5C4" />
          <stop offset="1" stopColor="#2AF5C4" stopOpacity="0" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="556.136"
          id={`${id}c`}
          width="556.183"
          x="-242.931"
          y="-207.712"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_10299_107459"
            stdDeviation="78.356"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="624.443"
          id={`${id}d`}
          width="624.49"
          x="-63.26"
          y="-241.866"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_10299_107459"
            stdDeviation="95.433"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="31.431"
          id={`${id}i`}
          width="24.103"
          x="93.37"
          y="-2.941"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.238" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10299_107459"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_10299_107459"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="11.537"
          id={`${id}k`}
          width="8.461"
          x="110.979"
          y="6.996"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.238" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10299_107459"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_10299_107459"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="64"
          id={`${id}l`}
          width="100"
          x="89"
          y="60"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10299_107459"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_10299_107459"
            result="shape"
          />
        </filter>
        <clipPath id={`${id}a`}>
          <rect fill="#fff" height="110" rx="10" width="277" />
        </clipPath>
        <clipPath id={`${id}b`}>
          <path d="M-28 0h335v141H-28z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EscapeRoomsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-27.5 w-[277px]", className)}
      fill="none"
      preserveAspectRatio="xMinYMin slice"
      viewBox="0 0 277 110"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}a)`}>
        <rect fill="#fff" fillOpacity="0.1" height="110" rx="10" width="277" />
        <g clipPath={`url(#${id}b)`}>
          <path d="M-28 0h335v141H-28z" fill="#fff" />
          <path d="M-28 0h335v141H-28z" fill="#000" fillOpacity="0.2" />
          <g filter={`url(#${id}c)`}>
            <ellipse
              cx="35.161"
              cy="70.356"
              fill="#4994D7"
              rx="121.379"
              ry="121.356"
            />
          </g>
          <path
            d="M251.279 13.618v118.644h-26.541V4.331h18.414v9.287h8.127z"
            fill={`url(#${id}d)`}
          />
          <path d="M199 14v84h-29V27.576h6.824V14H199z" fill={`url(#${id}e)`} />
          <path
            d="M123.723-1.653V99.054h32.198V-1.653h-8.135V-13.96h-4.745L139.991-30h-3.05l-3.05 16.039h-4.068v12.308h-6.1z"
            fill={`url(#${id}f)`}
          />
          <path
            d="M106 31.842V104H72V31.842h7.148L83.092 14h11.832l4.37 17.842H106z"
            fill={`url(#${id}g)`}
          />
          <path
            d="M58.303 10.447v88.98H24V-2.425h23.128v12.872h11.175z"
            fill={`url(#${id}h)`}
          />
          <g filter={`url(#${id}i)`}>
            <ellipse
              cx="248.985"
              cy="70.356"
              fill="#BAC"
              rx="121.379"
              ry="121.356"
            />
          </g>
          <path
            d="M-11.812 103.255a1.03 1.03 0 102.06 0 1.03 1.03 0 00-2.06 0z"
            fill={`url(#${id}j)`}
          />
          <path
            d="M-35.332 108.239a.851.851 0 101.702 0 .851.851 0 00-1.702 0z"
            fill={`url(#${id}k)`}
          />
          <path
            d="M-4 95.175a.6.6 0 101.202 0 .6.6 0 00-1.201 0z"
            fill={`url(#${id}l)`}
          />
          <path
            d="M-45.943 87.618a.75.75 0 101.502 0 .75.75 0 00-1.502 0z"
            fill={`url(#${id}m)`}
          />
          <path
            d="M-61.202 78.23a.901.901 0 101.802 0 .901.901 0 00-1.802 0z"
            fill={`url(#${id}n)`}
          />
          <path
            d="M-54.707 56.085a.75.75 0 101.502 0 .75.75 0 00-1.502 0z"
            fill={`url(#${id}o)`}
          />
          <path
            d="M-31.087 46.866a.5.5 0 101.001 0 .5.5 0 00-1 0z"
            fill={`url(#${id}p)`}
          />
          <path
            d="M-57.514 38.107a.65.65 0 101.301 0 .65.65 0 00-1.3 0z"
            fill={`url(#${id}q)`}
          />
          <path
            d="M-17.413 68.457a.55.55 0 101.101 0 .55.55 0 00-1.101 0z"
            fill={`url(#${id}r)`}
          />
          <path
            d="M4.696 55.68a.696.696 0 101.392 0 .696.696 0 00-1.392 0z"
            fill={`url(#${id}s)`}
          />
          <path
            d="M-17.062 55.626a.75.75 0 101.5 0 .75.75 0 00-1.5 0z"
            fill={`url(#${id}t)`}
          />
          <path
            d="M-66.959 109.018a.778.778 0 101.556 0 .778.778 0 00-1.555 0z"
            fill={`url(#${id}u)`}
          />
          <path
            d="M-79.164 64.64a.696.696 0 101.393 0 .696.696 0 00-1.393 0z"
            fill={`url(#${id}v)`}
          />
          <path
            d="M-85.556 38.167a.71.71 0 101.42 0 .71.71 0 00-1.42 0z"
            fill={`url(#${id}w)`}
          />
          <path
            d="M-91.35 118.528a1.263 1.263 0 102.526 0 1.263 1.263 0 00-2.526 0z"
            fill={`url(#${id}x)`}
          />
          <path
            d="M108.789 103.255a1.03 1.03 0 102.06 0 1.03 1.03 0 00-2.06 0z"
            fill={`url(#${id}y)`}
          />
          <path
            d="M85.27 108.239a.85.85 0 101.701 0 .85.85 0 00-1.701 0z"
            fill={`url(#${id}z)`}
          />
          <path
            d="M116.602 95.175a.6.6 0 101.202 0 .6.6 0 00-1.202 0z"
            fill={`url(#${id}A)`}
          />
          <path
            d="M74.659 87.618a.75.75 0 101.501 0 .75.75 0 00-1.501 0z"
            fill={`url(#${id}B)`}
          />
          <path
            d="M59.4 78.23a.901.901 0 101.801 0 .901.901 0 00-1.802 0z"
            fill={`url(#${id}C)`}
          />
          <path
            d="M61.185 62.992a.951.951 0 101.903 0 .951.951 0 00-1.903 0z"
            fill={`url(#${id}D)`}
          />
          <path
            d="M76.16 56.085a.75.75 0 101.502 0 .75.75 0 00-1.502 0z"
            fill={`url(#${id}E)`}
          />
          <path
            d="M84.369 74.707a.876.876 0 101.751 0 .876.876 0 00-1.751 0z"
            fill={`url(#${id}F)`}
          />
          <path
            d="M89.515 46.866a.5.5 0 101 0 .5.5 0 00-1 0z"
            fill={`url(#${id}G)`}
          />
          <path
            d="M47.54 55.635a.65.65 0 101.3 0 .65.65 0 00-1.3 0z"
            fill={`url(#${id}H)`}
          />
          <path
            d="M103.188 68.457a.551.551 0 101.102 0 .551.551 0 00-1.102 0z"
            fill={`url(#${id}I)`}
          />
          <path
            d="M125.297 55.68a.696.696 0 101.392 0 .696.696 0 00-1.392 0z"
            fill={`url(#${id}J)`}
          />
          <path
            d="M117.159 27.36a.75.75 0 101.5-.001.75.75 0 00-1.5 0z"
            fill={`url(#${id}K)`}
          />
          <path
            d="M53.643 109.018a.778.778 0 101.555 0 .778.778 0 00-1.555 0z"
            fill={`url(#${id}L)`}
          />
          <path
            d="M41.438 64.64a.696.696 0 101.392 0 .696.696 0 00-1.392 0z"
            fill={`url(#${id}M)`}
          />
          <path
            d="M24.136 80.73a.73.73 0 101.46.001.73.73 0 00-1.46 0z"
            fill={`url(#${id}N)`}
          />
          <path
            d="M18.648 58.306a.533.533 0 101.066 0 .533.533 0 00-1.066 0z"
            fill={`url(#${id}O)`}
          />
          <path
            d="M35.045 38.167a.71.71 0 101.42 0 .71.71 0 00-1.42 0z"
            fill={`url(#${id}P)`}
          />
          <path
            d="M29.252 118.528a1.263 1.263 0 102.526 0 1.263 1.263 0 00-2.526 0z"
            fill={`url(#${id}Q)`}
          />
          <ellipse
            cx="84.72"
            cy="65.954"
            fill="#292151"
            rx="12.055"
            ry="13.829"
          />
          <ellipse
            cx="148.194"
            cy="64.438"
            fill="#292151"
            rx="12.691"
            ry="12.483"
          />
          <path
            d="M191.368 71.552c0 7.266-9.162 7.657-13.311 6.958-5.396-.91-9.908-5.89-9.908-13.156 0-7.265 4.436-13.155 9.908-13.155 5.471 0 13.311 12.088 13.311 19.353zm-73.943-4.232c0 8.45 5.022 16.728-11.523 15.3-6.34-.547-11.522-6.85-11.522-15.3 0-8.45 5.159-15.3 11.522-15.3 6.364 0 11.523 6.85 11.523 15.3z"
            fill="#292151"
          />
          <path
            clipRule="evenodd"
            d="M204.494 66.858V16.852L130.55 15l-27.31 2.695-5.872 18.528-12.535 3.626a17.846 17.846 0 00-12.243 12.39c-1.16.888-2.74 3.177-2.28 7.298h1.443l-.247 3.964v5.187l53.225 1.439 79.763-3.27z"
            fill={`url(#${id}R)`}
            fillRule="evenodd"
          />
          <path
            d="M177.903 25.187c3.113-.144 5.467-1.745 6.789-3.13.402-.422 1.132-.422 1.535 0 1.322 1.385 3.676 2.986 6.789 3.13.851.04 1.95 1.638 1.829 2.482a5.973 5.973 0 00.04 1.918c.54 3.002 2.883 7.505 1.082 10.807-1.43 2.621-7.492 6.365-10.508 8.045-2.982-1.661-9.067-5.404-10.508-8.045-1.801-3.302.542-7.805 1.083-10.806a6 6 0 00.039-1.92c-.12-.843.978-2.442 1.83-2.481z"
            fill="#9AAAF1"
          />
          <path
            d="M180.232 27.212c1.964-.27 3.488-1.268 4.441-2.198.417-.407 1.155-.407 1.572 0 .953.93 2.477 1.928 4.441 2.198.844.117 2.063 1.838 2.069 2.69.003.26.026.532.077.816.423 2.348 2.256 5.87.847 8.454-1.118 2.05-5.861 4.98-8.22 6.293-2.333-1.3-7.093-4.227-8.22-6.293-1.409-2.583.424-6.106.846-8.454.051-.284.075-.556.077-.815.007-.853 1.225-2.574 2.07-2.69z"
            stroke="#768BF3"
            strokeLinecap="round"
            strokeWidth="2.487"
          />
          <path
            clipRule="evenodd"
            d="M131.867 15.033l-6.926 22.137c-9.763 1.771-36.507 12.62-36.507 22.701h-16.7l.02-.334h-1.443c-.46-4.12 1.12-6.41 2.28-7.299a17.846 17.846 0 0112.242-12.39l12.536-3.625 5.872-18.528L130.551 15l1.316.033z"
            fill={`url(#${id}S)`}
            fillRule="evenodd"
          />
          <path
            d="M93.644 54.766c-.273.086-.55.28-.815.532-1.087 1.034-.058 2.708 1.442 2.708h3.117c.74 0 1.474-.261 1.926-.848.627-.813 1.158-1.87.778-2.595-.676-1.282-5.064-.236-6.448.203z"
            fill="#fff"
          />
          <path
            clipRule="evenodd"
            d="M70.228 57.967c1.274-.258 2.037-1.729 1.048-2.669-.17-.162-.345-.3-.52-.4-.306.835-.513 1.853-.528 3.07z"
            fill="#fff"
            fillRule="evenodd"
          />
          <circle cx="168.916" cy="21.224" fill="#fff" r="0.766" />
          <circle cx="168.916" cy="36.822" fill="#733070" r="0.766" />
          <circle cx="168.916" cy="56.674" fill="#fff" r="0.766" />
          <circle cx="202.002" cy="21.679" fill="#fff" r="0.766" />
          <circle cx="202.002" cy="35.86" fill="#fff" r="0.766" />
          <circle cx="202.002" cy="54.767" fill="#fff" r="0.766" />
          <path
            d="M132.107 22.426l13.744.26-.272 34.155-16.273.333-2.276-4.3.478-15.346 4.599-15.102zm16.507.28l14.217.269-.123 43.729-13.992.3-.102-44.298z"
            stroke="#374DB3"
            strokeLinecap="round"
            strokeWidth="1.58"
          />
          <ellipse
            cx="111.403"
            cy="67.32"
            fill={`url(#${id}T)`}
            rx="11.522"
            ry="15.3"
          />
          <path
            d="M125.644 70.207c0-13.052-3.405-23.632-19.84-23.632-10.957 0-19.84 10.58-19.84 23.632"
            stroke="#374DB3"
            strokeWidth="1.58"
          />
          <path
            d="M128.098 24.945v0c1.118 0 2.024.907 2.024 2.025v11.097a2.024 2.024 0 01-2.024 2.024v0"
            stroke="#374DB3"
            strokeLinecap="round"
            strokeWidth="2.369"
          />
          <path
            d="M132.178 28.29l-1.234 5.817a2.38 2.38 0 002.287 2.872l9.394.16a1.189 1.189 0 001.209-1.17l.139-8.214a1.189 1.189 0 00-1.169-1.21l-8.258-.14a2.38 2.38 0 00-2.368 1.885z"
            fill="#372B76"
          />
          <rect
            fill="#fff"
            height="10.646"
            rx="2.098"
            width="4.196"
            x="128.69"
            y="26.865"
          />
          <path
            d="M67.944 59.388c.86.107 23.799.627 35.018.935l-.927 8.968a2.317 2.317 0 01-2.32 2.098c-5.948-.05-20.71-.434-28.659-1.453-1.96-.251-3.557-1.63-3.785-3.594-.373-3.222-.113-7.052.673-6.954z"
            fill="#fff"
          />
          <path
            d="M152.3 30.11l-.033 1.93a2.38 2.38 0 002.338 2.42l2.446.041a2.379 2.379 0 002.419-2.338l.033-1.931a2.38 2.38 0 00-2.339-2.42l-2.445-.04a2.379 2.379 0 00-2.419 2.338zm-9.693 30.621l-3.115.205a1.99 1.99 0 00.13 3.975h3.122a2.092 2.092 0 10-.137-4.18zm15.011-17.128l-.042 2.498a.828.828 0 001.656.028l.042-2.498a.828.828 0 00-1.656-.028zm-15.453-.131l-.042 2.498a.827.827 0 101.655.028l.043-2.498a.828.828 0 00-1.656-.028z"
            fill="#413776"
          />
          <ellipse
            cx="112.031"
            cy="67.638"
            fill="#91A1E9"
            rx="6.225"
            ry="8.266"
          />
          <ellipse
            cx="112.032"
            cy="67.638"
            fill="#413776"
            rx="2.409"
            ry="3.199"
          />
          <path
            d="M124.662 31.27l4.611-14.346-25.04 2.154-3.939 12.394a2.379 2.379 0 002.267 3.1h17.571a4.76 4.76 0 004.53-3.303z"
            fill="#372B76"
          />
          <path
            clipRule="evenodd"
            d="M114.481 34.571l-11.143-12.676.895-2.817 1.902-.163 16.876 14.687a4.75 4.75 0 01-2.878.97h-5.652z"
            fill={`url(#${id}U)`}
            fillRule="evenodd"
          />
          <path
            d="M84.637 44.922c-.678-.415-2.449-.518-4.346-.469-3.265.086-5.852 2.363-6.199 5.61a61.911 61.911 0 00-.296 4.076c-.092 2.325 1.72 4.196 4.042 4.328 2.93.166 6.52.244 7.312-.298 1.383-.95.865-12.403-.513-13.247z"
            fill="#606CBB"
          />
          <path
            clipRule="evenodd"
            d="M76.931 45.444a6.077 6.077 0 00-1.658 1.536v10.485a4.324 4.324 0 001.658.857V45.444zm2.305 13.092a91.59 91.59 0 01-1.397-.069 4.541 4.541 0 01-.26-.022V45.089a6.558 6.558 0 011.657-.529v13.976zm2.306.054a53.45 53.45 0 01-1.658-.03V44.476a7.18 7.18 0 01.407-.023c.427-.01.848-.014 1.25-.008V58.59zm2.305-.094c-.475.052-1.04.08-1.658.09V44.464c.635.029 1.205.087 1.658.183v13.85z"
            fill="#4F4F96"
            fillRule="evenodd"
          />
          <path
            d="M97.352 36.183h18.884a8.327 8.327 0 018.327 8.327v14.658"
            stroke="#374DB3"
            strokeLinecap="round"
            strokeWidth="1.58"
          />
          <ellipse
            cx="184.202"
            cy="65.175"
            fill={`url(#${id}V)`}
            rx="9.907"
            ry="13.155"
          />
          <ellipse
            cx="185.101"
            cy="65.025"
            fill="#91A1E9"
            rx="5.385"
            ry="7.151"
          />
          <ellipse
            cx="185.101"
            cy="65.025"
            fill="#413776"
            rx="1.715"
            ry="2.277"
          />
          <path
            d="M196.542 68.555v-8.379h9.476v7.973l-9.476.406z"
            fill="#fff"
          />
          <path
            d="M177.28 26.849c-.358 3.395-2.888 5.81-6.157 5.464-3.269-.344-5.629-3.377-5.271-6.772.358-3.396 3.298-5.87 6.567-5.524 3.269.344 5.219 3.436 4.861 6.832z"
            fill="#733070"
          />
          <path
            d="M176.864 18.098c-2.623.013-3.446 2.634-3.53 3.942l.425.284c.68-.739 2.489-1.593 4.289.898 1.8 2.492 4.416 2.028 5.499 1.484-2.572.458-3.405-6.624-6.683-6.608z"
            fill="#733070"
          />
          <path
            d="M198.387 74.65c-7.573-3.59-4.045-15.623-3.671-19.317.05-1.066-.039-2.903.595-2.786 1.192 1.753 12.972 6.045 16.823 11.268 3.851 5.224-4.28 15.323-13.747 10.835z"
            fill="#FFA670"
          />
          <path
            clipRule="evenodd"
            d="M197.464 54.07c.75.422 1.647.893 2.628 1.409 4.086 2.147 9.626 5.058 12.043 8.336 2.716 3.684-.528 9.793-5.997 11.5 1.17-1.55 2.632-4.363 1.822-6.91-.572-1.797-1.383-2.361-2.064-2.835-.717-.499-1.291-.898-1.291-2.533 0-2.452-4.469-6.79-7.141-8.967z"
            fill="#E3854C"
            fillRule="evenodd"
          />
          <path
            d="M186.768 86.47l-.646-2.197 2.541-.862.732 2.412-2.627.647zm-12.433 1.51l-.056-2.29 2.678-.174.083 2.52-2.705-.056z"
            fill="#F3898A"
          />
          <path
            d="M168.213 65.798l3.708-12.85h12.969c-.306 2.797-2.458 11.421-3.497 15.384l8.29 15.544-4.412.92-8.051-11.805a10.255 10.255 0 01-1.649-7.435l.97-5.927-3.03 9.974 4.47 16.337h-4.47l-5.067-13.752a10.26 10.26 0 01-.231-6.39z"
            fill="#CCDAFF"
          />
          <path
            clipRule="evenodd"
            d="M184.623 54.642c-3.746 1.7-9.986-.146-12.788-1.359l1.401-.335h11.653a24.7 24.7 0 01-.266 1.694zm-8.14 5.176l.042-.158-.625-2.98-2.321 12.696 2.904-9.558zm-2.956 9.845l.022.084-.041.016.019-.1z"
            fill="#A2B4E4"
            fillRule="evenodd"
          />
          <path
            d="M189.28 84.858l1.349 3.7-8.834 3.263c-.29-.03-.775-.514-.392-2.22.383-1.705 2.916-1.987 4.134-1.914l.871-2.176 2.872-.653zm-12.1 2.215l.346 3.923-9.378.866c-.273-.103-.615-.697.196-2.245.811-1.549 3.331-1.165 4.489-.78l1.404-1.876 2.943.112z"
            fill="#4D0D54"
          />
          <path
            d="M195.707 52.546c.017-.22-.995-1.418-1.503-1.99l-2.201.7v2.073c0 .53.487.445.508.678.021.233.466 1.248 1.333 1.29.868.043 1.842-2.476 1.863-2.75z"
            fill="#F3898A"
          />
          <path
            d="M149.669 40.296c.709-.832 2.334-2.158 3.156-.807.822 1.35 2.104 10.055 2.642 14.239"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="1.807"
          />
          <path
            d="M156.094 47.217c.137.081.427.288.556.71l.555 1.706c-.691.034-2.282.081-3.12 0-1.047-.102-1.133-1.908-1.133-2.416s.77-.508.77-.737c0-.229 1.175-.229 1.645-.229.471 0 .556.864.727.966z"
            fill="#F3898A"
          />
          <path
            d="M190.603 50.95c.41 0 1.332.684 1.742 1.025.601.164.728.82.717 1.127-.847.437-1.855 1.434-2.254 1.878-.432-.455-1.297-1.468-1.297-1.878 0-.41.728-.535 1.092-.546-.17-.535-.409-1.605 0-1.605z"
            fill="#FFA670"
          />
          <path
            d="M166.156 46.067l.694-4.208a12.856 12.856 0 017.077-9.475 10.718 10.718 0 0110.186 2.034l2.083 1.765a20.515 20.515 0 015.826 8.136l2.452 6.227-2.726 1.083-4.301-8.894-4.831-3.4c2.756 4.388 2.576 10.19 2.254 13.545-3.81 2.61-10.594.864-12.996.435.454-3.778-.835-7.678-.97-10.388l-.943 3.216a4.884 4.884 0 01-4.529 3.508l-8.564.277c-.179-.162-.297-1.588-.333-2.184l9.621-1.677z"
            fill="#4D0D54"
          />
          <path
            clipRule="evenodd"
            d="M193.958 49.235l-1.826-4.638a40.473 40.473 0 01-3.141 1.332l2.174 4.494a46.087 46.087 0 002.793-1.188zm-9.041 3.12c.121-1.436.195-3.23.047-5.14-1.62.431-3.245.761-4.856.997a41.43 41.43 0 01-8.368.384c.208 1.53.324 3.135.134 4.72.254.045.558.105.902.173l.724.143a47.119 47.119 0 007.327-.498 48.259 48.259 0 004.09-.78zm-27.132-2.456l7.647-.248a4.884 4.884 0 003.233-1.366c-.139-.02-.278-.041-.415-.063l.434.044a4.873 4.873 0 001.277-2.123l.793-2.706a35.522 35.522 0 01-4.089-.456l-.509 3.086-9.621 1.678c.018.294.056.79.111 1.237.184.255.42.479.704.654.143.09.288.177.435.263zm16.887-17.724c-.25.06-.498.13-.745.209a12.852 12.852 0 00-5.276 4.725c3.348.252 6.914.123 10.505-.412 2.018-.3 4.064-.732 6.108-1.304l-1.151-.975a10.719 10.719 0 00-6.471-2.531 44.33 44.33 0 01-2.97.288zm11.089 3.64a44.848 44.848 0 01-6.867 1.58c-3.753.56-7.353.612-10.571.265a12.837 12.837 0 00-1.473 4.2l-.102.62c4.009.537 8.424.498 12.879-.165a50.08 50.08 0 004.096-.786 13.581 13.581 0 00-1.107-2.194l2.588 1.821a48.85 48.85 0 004.328-1.378 20.511 20.511 0 00-3.336-3.595l-.435-.368zm4.026 4.323a42.948 42.948 0 01-3.997 1.431l1.657 1.166 1.474 3.048a47.818 47.818 0 003.194-1.229l-.093-.235a20.493 20.493 0 00-2.235-4.181zm-4.844 6.827c-.141-1.602-.443-3.275-1.01-4.876a44.99 44.99 0 01-4.568.924 42.92 42.92 0 01-8.423.433c.078.835.24 1.765.412 2.756.126.722.257 1.476.366 2.25a48.35 48.35 0 008.378-.519 49.986 49.986 0 004.845-.968z"
            fill="#7469A3"
            fillRule="evenodd"
          />
          <circle cx="173.508" cy="33.424" fill="#CE5E60" r="1.995" />
          <ellipse
            cx="176.426"
            cy="28.476"
            fill="#CE5E60"
            rx="0.849"
            ry="1.414"
            transform="rotate(10.913 176.426 28.476)"
          />
          <path
            d="M166.15 26.816l8.402-3.126 1.087 3.21a6.187 6.187 0 01-3.875 7.844 2.68 2.68 0 01-3.387-1.644l-2.227-6.284z"
            fill="#F3898A"
          />
          <path
            d="M169.697 30.471c-.101.24-.304.796-.304 1.106 0 .31.332.424.498.442m1.691.935c.322.008 1.03-.126 1.282-.72"
            stroke="#CE5E60"
            strokeLinecap="round"
            strokeWidth="0.829"
          />
          <path
            d="M167.217 31.087c-.515-.832-.745-2.462-.8-3.12l9.846-1.535v1.398s-.491 1.945-1.931 2.606c-1.047.48-2.388.336-3.618.168a3.517 3.517 0 00-2.427.569c-.361.24-.841.284-1.07-.086z"
            fill="#4D0D54"
          />
          <ellipse
            cx="167.813"
            cy="29.495"
            fill="#fff"
            rx="0.273"
            ry="0.566"
            transform="rotate(-8.188 167.813 29.495)"
          />
          <ellipse
            cx="171.513"
            cy="28.973"
            fill="#fff"
            rx="0.273"
            ry="0.566"
            transform="rotate(-8.188 171.513 28.973)"
          />
          <path
            d="M168.825 25.933c-1.142 3.58-2.192 3.52-3.292 3.301-2.271-4.79 4.041-7.184 8.61-7.184l2.271 3.052.248.83-.468 3.579c-.324-1.127-.763-2.357-2.86-2.82-2.098-.462-3.806-.467-4.509-.758z"
            fill="#733070"
          />
        </g>
        <path
          d="M138.5 74C10.094 74-94 118.772-94 174h465c0-55.228-104.094-100-232.5-100z"
          fill="#2B2C3F"
        />
        <g fill="#fff" filter={`url(#${id}W)`}>
          <path
            clipRule="evenodd"
            d="M82.122 90.77c-.61 1.012-2.279 1.157-3.945.426l-.604 1.003-1.256 2.086 1.49.895a.375.375 0 01.13.515l-.212.35a.375.375 0 01-.514.129l-.277-.167a.375.375 0 00-.514.129l-.314.522a.375.375 0 00.128.514l.277.167a.375.375 0 01.128.514l-.17.285a.375.375 0 01-.515.128l-1.494-.897-.264.438a.818.818 0 01-1.4-.844l1.807-3.002 1.57-2.606.603-1.002c-1.43-1.13-2.085-2.678-1.475-3.69.699-1.161 2.792-1.182 4.676-.048 1.883 1.134 2.844 2.995 2.145 4.155zm-2.505-3.527c.456.275.69.769.63 1.234.229.001.465.064.681.194.6.362.816 1.104.482 1.659-.334.554-1.091.71-1.691.35a1.34 1.34 0 01-.491-.512c-.383.27-.93.295-1.385.02-.456-.274-.69-.769-.63-1.233a1.339 1.339 0 01-.681-.195c-.6-.361-.816-1.104-.482-1.658.334-.555 1.09-.711 1.69-.35.217.13.383.31.492.511.383-.27.929-.294 1.385-.02z"
            fillRule="evenodd"
          />
          <path d="M78.177 91.196l.15-.343a.375.375 0 00-.471.15l.321.193zm3.945-.426l-.321-.194.321.194zm-4.549 1.429l.321.193-.32-.193zm-1.256 2.086l-.321-.194a.375.375 0 00.128.515l.193-.321zm1.49.895l.194-.321-.193.321zm.13.515l.32.193-.32-.193zm-.212.35l-.32-.193.32.193zm-.514.129l-.193.321.193-.321zm-.277-.167l.193-.321-.193.321zm-.514.129l.321.193-.322-.193zm-.314.522l-.322-.193.322.193zm.128.514l-.193.322.193-.322zm.277.167l.193-.322-.193.322zm.128.514l.322.193-.322-.193zm-.17.285l-.322-.193.321.193zm-.515.128l-.194.322.194-.322zm-1.494-.897l.193-.322a.375.375 0 00-.514.128l.32.194zm-.264.438l-.322-.193.322.193zm-1.122.279l-.194.32.194-.32zm-.279-1.123l-.321-.193.321.194zm1.808-3.002l-.321-.194.321.194zm1.57-2.606l.32.194-.32-.194zm.603-1.002l.321.194a.375.375 0 00-.089-.488l-.232.294zm-1.475-3.69l.321.193-.32-.194zm4.676-.048l.193-.321-.193.321zm.27 1.862l-.372-.048a.375.375 0 00.369.423l.002-.375zm-.63-1.234l.193-.321-.193.321zm1.311 1.428l.194-.32-.194.32zm.482 1.659l.321.193-.321-.193zm-1.691.35l.193-.322-.193.322zm-.491-.512l.33-.178a.375.375 0 00-.546-.128l.216.306zm-1.385.02l-.193.322.193-.322zm-.63-1.233l.372.048a.375.375 0 00-.37-.423l-.002.375zm-.681-.195l-.194.321.194-.32zm-.482-1.658l-.322-.194.322.194zm1.69-.35l.194-.321-.193.321zm.492.511l-.33.178a.375.375 0 00.546.129l-.216-.306zm-.206 4.277c.88.386 1.78.55 2.558.47.777-.08 1.475-.408 1.86-1.047l-.643-.386c-.225.373-.666.623-1.293.687-.625.063-1.394-.066-2.18-.411l-.302.687zm-.132.852l.604-1.002-.642-.387-.604 1.002.642.387zm-1.256 2.086l1.256-2.086-.642-.387-1.256 2.086.642.387zm1.363.38l-1.49-.895-.387.643 1.49.896.387-.643zm.256 1.03a.75.75 0 00-.256-1.029l-.386.643.642.386zm-.21.35l.21-.35-.642-.386-.21.35.642.386zm-1.03.257a.75.75 0 001.03-.257l-.643-.386-.386.643zm-.276-.166l.277.166.386-.643-.277-.166-.386.643zm0 0l.386-.643a.75.75 0 00-1.029.256l.643.387zm-.314.522l.314-.522-.643-.386-.314.522.643.386zm0 0l-.643-.386a.75.75 0 00.257 1.029l.386-.643zm.277.166l-.277-.166-.386.643.277.166.386-.643zm.257 1.03a.75.75 0 00-.257-1.03l-.386.643.643.386zm-.171.284l.17-.285-.642-.386-.171.285.643.386zm-1.03.257a.75.75 0 001.03-.257l-.643-.386-.387.643zm-1.493-.898l1.493.898.387-.643-1.494-.898-.386.643zm.25.31l.264-.438-.642-.387-.264.439.642.386zm-1.637.407c.564.34 1.297.158 1.637-.406l-.642-.387a.443.443 0 01-.608.15l-.387.643zm-.406-1.637a1.193 1.193 0 00.406 1.637l.387-.643a.443.443 0 01-.15-.607l-.643-.387zm1.808-3.002l-1.808 3.002.642.387 1.808-3.003-.642-.386zm1.57-2.606l-1.57 2.605.642.387 1.57-2.605-.643-.387zm.602-1.002l-.603 1.002.643.387.603-1.002-.642-.387zm-1.474-3.691c-.385.64-.349 1.411-.054 2.136.295.726.862 1.445 1.617 2.043l.465-.589c-.674-.534-1.15-1.153-1.387-1.737-.238-.585-.224-1.093.001-1.466l-.642-.387zm5.19-.175c-.991-.597-2.053-.9-2.979-.891-.92.01-1.77.332-2.211 1.066l.642.387c.258-.428.803-.695 1.576-.703.767-.008 1.693.246 2.586.783l.386-.642zm2.273 4.67c.442-.734.33-1.637-.092-2.453-.425-.823-1.19-1.62-2.18-2.217l-.388.642c.893.537 1.55 1.238 1.902 1.919.355.687.373 1.294.116 1.721l.642.387zm-1.825-2.439c.08-.62-.231-1.256-.808-1.603l-.387.642c.335.202.492.555.452.865l.743.096zm.504-.175a1.714 1.714 0 00-.873-.248l-.005.75a.965.965 0 01.49.14l.388-.642zm.61 2.173c.454-.755.143-1.72-.61-2.173l-.387.643c.447.269.567.79.354 1.143l.642.387zm-2.207.478c.753.453 1.751.278 2.206-.478l-.642-.387c-.213.354-.73.492-1.177.222l-.387.643zm-.627-.656c.14.262.353.49.627.656l.387-.643a.964.964 0 01-.354-.368l-.66.356zm-1.248.165c.576.347 1.284.325 1.794-.036l-.432-.612c-.255.18-.64.207-.975.005l-.387.643zm-.809-1.604c-.08.62.232 1.256.809 1.604l.386-.643c-.335-.202-.49-.555-.45-.864l-.745-.097zm-.503.175c.274.165.576.247.873.249l.005-.75a.964.964 0 01-.491-.141l-.387.642zm-.61-2.173c-.454.756-.143 1.72.61 2.173l.387-.642c-.447-.27-.567-.79-.354-1.144l-.642-.387zm2.206-.477c-.753-.454-1.75-.278-2.206.477l.643.387c.213-.354.73-.491 1.177-.222l.386-.642zm.628.655a1.714 1.714 0 00-.628-.655l-.386.642a.964.964 0 01.353.368l.661-.355zm1.248-.164c-.576-.347-1.284-.326-1.795.035l.433.613c.255-.18.64-.207.975-.006l.387-.642zm16.237 1.718v2.8h3.76v1.776h-3.76v2.96h4.24V98h-6.48V86.816h6.48v1.824h-4.24zm9.668 9.504c-.726 0-1.376-.128-1.952-.384-.576-.267-1.035-.624-1.376-1.072a2.725 2.725 0 01-.544-1.488h2.256c.042.341.208.624.496.848.298.224.666.336 1.104.336.426 0 .757-.085.992-.256.245-.17.368-.39.368-.656 0-.288-.15-.501-.448-.64-.288-.15-.752-.31-1.392-.48a12.195 12.195 0 01-1.632-.496 2.898 2.898 0 01-1.088-.784c-.299-.352-.448-.827-.448-1.424 0-.49.138-.939.416-1.344.288-.405.693-.725 1.216-.96.533-.235 1.157-.352 1.872-.352 1.056 0 1.898.267 2.528.8.629.523.976 1.232 1.04 2.128h-2.144a1.127 1.127 0 00-.448-.832c-.256-.213-.603-.32-1.04-.32-.406 0-.72.075-.944.224a.718.718 0 00-.32.624c0 .299.149.528.448.688.298.15.762.304 1.392.464.64.16 1.168.325 1.584.496.416.17.773.437 1.072.8.309.352.469.821.48 1.408 0 .512-.144.97-.432 1.376-.278.405-.683.725-1.216.96-.523.224-1.136.336-1.84.336zm4.75-4.576c0-.917.187-1.717.561-2.4a3.93 3.93 0 011.552-1.6c.661-.384 1.418-.576 2.272-.576 1.098 0 2.005.277 2.72.832.725.544 1.21 1.312 1.456 2.304h-2.416a1.71 1.71 0 00-.656-.896c-.299-.224-.672-.336-1.12-.336-.64 0-1.147.235-1.52.704-.374.459-.56 1.115-.56 1.968 0 .843.186 1.499.56 1.968.373.459.88.688 1.52.688.906 0 1.498-.405 1.776-1.216h2.416c-.246.96-.731 1.723-1.456 2.288-.726.565-1.632.848-2.72.848-.854 0-1.611-.187-2.272-.56a4.065 4.065 0 01-1.552-1.6c-.374-.693-.561-1.499-.561-2.416zm9.625-.032c0-.896.176-1.69.528-2.384.363-.693.849-1.227 1.457-1.6a3.915 3.915 0 012.064-.56c.661 0 1.237.133 1.728.4a3.51 3.51 0 011.2 1.008v-1.264h2.256V98h-2.256v-1.296c-.288.416-.688.763-1.2 1.04-.502.267-1.083.4-1.744.4-.747 0-1.43-.192-2.048-.576-.608-.384-1.094-.923-1.457-1.616-.352-.704-.528-1.51-.528-2.416zm6.977.032c0-.544-.107-1.008-.32-1.392a2.198 2.198 0 00-.864-.896 2.266 2.266 0 00-1.168-.32c-.416 0-.8.101-1.153.304a2.336 2.336 0 00-.863.896c-.214.384-.32.843-.32 1.376 0 .533.106 1.003.32 1.408.224.395.512.699.863.912.363.213.747.32 1.153.32.416 0 .805-.101 1.168-.304.362-.213.65-.512.864-.896.213-.395.32-.864.32-1.408zm6.683-3.152c.288-.405.683-.741 1.184-1.008.512-.277 1.094-.416 1.744-.416a3.834 3.834 0 013.504 2.16c.363.683.544 1.477.544 2.384 0 .907-.181 1.712-.544 2.416-.352.693-.837 1.232-1.456 1.616a3.754 3.754 0 01-2.048.576c-.65 0-1.226-.133-1.728-.4a3.73 3.73 0 01-1.2-1.008v5.488h-2.24V89.136h2.24v1.28zm4.688 3.12c0-.533-.112-.992-.336-1.376a2.185 2.185 0 00-.864-.896 2.268 2.268 0 00-1.152-.304c-.405 0-.789.107-1.152.32-.352.203-.64.501-.864.896-.213.395-.32.859-.32 1.392 0 .533.107.997.32 1.392.224.395.512.699.864.912.363.203.747.304 1.152.304.416 0 .8-.107 1.152-.32a2.29 2.29 0 00.864-.912c.224-.395.336-.864.336-1.408zm12.156-.16c0 .32-.021.608-.064.864h-6.48c.053.64.277 1.141.672 1.504s.88.544 1.456.544c.832 0 1.424-.357 1.776-1.072h2.416a4.08 4.08 0 01-1.472 2.112c-.725.544-1.616.816-2.672.816-.853 0-1.621-.187-2.304-.56a4.122 4.122 0 01-1.584-1.616c-.373-.693-.56-1.493-.56-2.4 0-.917.187-1.723.56-2.416a3.905 3.905 0 011.568-1.6c.672-.373 1.445-.56 2.32-.56.843 0 1.595.181 2.256.544.672.363 1.189.88 1.552 1.552.373.661.56 1.424.56 2.288zm-2.32-.64c-.011-.576-.219-1.035-.624-1.376-.405-.352-.901-.528-1.488-.528-.555 0-1.024.17-1.408.512-.373.33-.603.795-.688 1.392h4.208zm10.008-2.224c.288-.47.661-.837 1.12-1.104.469-.267 1.002-.4 1.6-.4v2.352h-.592c-.704 0-1.238.165-1.6.496-.352.33-.528.907-.528 1.728V98h-2.24v-8.864h2.24v1.376zm8.164 7.632c-.853 0-1.621-.187-2.304-.56a4.208 4.208 0 01-1.616-1.616c-.384-.693-.576-1.493-.576-2.4 0-.907.198-1.707.592-2.4a4.175 4.175 0 011.648-1.6c.694-.384 1.467-.576 2.32-.576.854 0 1.627.192 2.32.576a4.053 4.053 0 011.632 1.6c.406.693.608 1.493.608 2.4 0 .907-.208 1.707-.624 2.4a4.25 4.25 0 01-1.664 1.616c-.693.373-1.472.56-2.336.56zm0-1.952c.406 0 .784-.096 1.136-.288.363-.203.651-.501.864-.896.214-.395.32-.875.32-1.44 0-.843-.224-1.488-.672-1.936a2.144 2.144 0 00-1.616-.688c-.64 0-1.178.23-1.616.688-.426.448-.64 1.093-.64 1.936s.208 1.493.624 1.952c.427.448.96.672 1.6.672zm10.203 1.952c-.853 0-1.621-.187-2.304-.56a4.208 4.208 0 01-1.616-1.616c-.384-.693-.576-1.493-.576-2.4 0-.907.198-1.707.592-2.4a4.175 4.175 0 011.648-1.6c.694-.384 1.467-.576 2.32-.576.854 0 1.627.192 2.32.576a4.053 4.053 0 011.632 1.6c.406.693.608 1.493.608 2.4 0 .907-.208 1.707-.624 2.4a4.25 4.25 0 01-1.664 1.616c-.693.373-1.472.56-2.336.56zm0-1.952c.406 0 .784-.096 1.136-.288.363-.203.651-.501.864-.896.214-.395.32-.875.32-1.44 0-.843-.224-1.488-.672-1.936a2.144 2.144 0 00-1.616-.688c-.64 0-1.178.23-1.616.688-.426.448-.64 1.093-.64 1.936s.208 1.493.624 1.952c.427.448.96.672 1.6.672zm17.276-7.184c1.088 0 1.962.336 2.624 1.008.672.661 1.008 1.59 1.008 2.784V98h-2.24v-4.896c0-.693-.176-1.221-.528-1.584-.352-.373-.832-.56-1.44-.56s-1.094.187-1.456.56c-.352.363-.528.89-.528 1.584V98h-2.24v-4.896c0-.693-.176-1.221-.528-1.584-.352-.373-.832-.56-1.44-.56-.619 0-1.11.187-1.472.56-.352.363-.528.89-.528 1.584V98h-2.24v-8.864h2.24v1.072a2.997 2.997 0 011.104-.88 3.52 3.52 0 011.504-.32c.693 0 1.312.15 1.856.448.544.288.965.704 1.264 1.248a3.223 3.223 0 011.248-1.232 3.619 3.619 0 011.792-.464zm9.149 9.136c-.725 0-1.376-.128-1.952-.384-.576-.267-1.035-.624-1.376-1.072a2.725 2.725 0 01-.544-1.488h2.256c.043.341.208.624.496.848.299.224.667.336 1.104.336.427 0 .757-.085.992-.256.245-.17.368-.39.368-.656 0-.288-.149-.501-.448-.64-.288-.15-.752-.31-1.392-.48a12.287 12.287 0 01-1.632-.496 2.898 2.898 0 01-1.088-.784c-.299-.352-.448-.827-.448-1.424 0-.49.139-.939.416-1.344.288-.405.693-.725 1.216-.96.533-.235 1.157-.352 1.872-.352 1.056 0 1.899.267 2.528.8.629.523.976 1.232 1.04 2.128h-2.144a1.124 1.124 0 00-.448-.832c-.256-.213-.603-.32-1.04-.32-.405 0-.72.075-.944.224a.72.72 0 00-.32.624c0 .299.149.528.448.688.299.15.763.304 1.392.464.64.16 1.168.325 1.584.496.416.17.773.437 1.072.8.309.352.469.821.48 1.408 0 .512-.144.97-.432 1.376-.277.405-.683.725-1.216.96-.523.224-1.136.336-1.84.336z" />
        </g>
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}d`}
          x1="241.701"
          x2="241.701"
          y1="-25.406"
          y2="97.964"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}e`}
          x1="184.5"
          x2="184.5"
          y1="-32.269"
          y2="98"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}f`}
          x1="139.822"
          x2="139.822"
          y1="-65.973"
          y2="99.054"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}g`}
          x1="89"
          x2="89"
          y1="-35.574"
          y2="104"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}h`}
          x1="41.152"
          x2="41.152"
          y1="-22.291"
          y2="99.427"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}j`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}k`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}l`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}m`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}n`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}o`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}p`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}q`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}r`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}s`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}t`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}u`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}v`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}w`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}x`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}y`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}z`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}A`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}B`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}C`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}D`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}E`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}F`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}G`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}H`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}I`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}J`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}K`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}L`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}M`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}N`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}O`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}P`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}Q`}
          x1="42.926"
          x2="41.383"
          y1="-47.236"
          y2="187.992"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}R`}
          x1="137.361"
          x2="271.397"
          y1="25.843"
          y2="108.61"
        >
          <stop stopColor="#576FEF" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}S`}
          x1="128.674"
          x2="88.727"
          y1="56.061"
          y2="35.509"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}T`}
          x1="111.403"
          x2="111.403"
          y1="61.882"
          y2="85.233"
        >
          <stop stopColor="#413776" />
          <stop offset="1" stopColor="#687BCF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}U`}
          x1="113.387"
          x2="113.387"
          y1="17.607"
          y2="36.031"
        >
          <stop stopColor="#8A7FC7" />
          <stop offset="1" stopColor="#413776" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}V`}
          x1="184.202"
          x2="184.202"
          y1="60.5"
          y2="80.578"
        >
          <stop stopColor="#413776" />
          <stop offset="1" stopColor="#687BCF" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="556.136"
          id={`${id}c`}
          width="556.183"
          x="-242.931"
          y="-207.712"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_10299_107223"
            stdDeviation="78.356"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="624.443"
          id={`${id}i`}
          width="624.49"
          x="-63.26"
          y="-241.866"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_10299_107223"
            stdDeviation="95.433"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="64"
          id={`${id}W`}
          width="177"
          x="50.5"
          y="60"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10299_107223"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_10299_107223"
            result="shape"
          />
        </filter>
        <clipPath id={`${id}a`}>
          <rect fill="#fff" height="110" rx="10" width="277" />
        </clipPath>
        <clipPath id={`${id}b`}>
          <path d="M-28 0h335v141H-28z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function HauntsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-27.5 w-[277px]", className)}
      fill="none"
      preserveAspectRatio="xMinYMin slice"
      viewBox="0 0 277 110"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}a)`}>
        <rect fill="#fff" fillOpacity="0.1" height="110" rx="10" width="277" />
        <g clipPath={`url(#${id}b)`}>
          <path d="M-28 0h335v141H-28z" fill="#fff" />
          <path d="M-28 0h335v141H-28z" fill="#000" fillOpacity="0.2" />
          <g filter={`url(#${id}c)`}>
            <ellipse
              cx="35.161"
              cy="70.356"
              fill="#3E2AA3"
              rx="121.379"
              ry="121.356"
            />
          </g>
          <g filter={`url(#${id}d)`}>
            <ellipse
              cx="248.985"
              cy="70.356"
              fill="#104BA3"
              rx="121.379"
              ry="121.356"
            />
          </g>
          <g filter={`url(#${id}e)`}>
            <path
              clipRule="evenodd"
              d="M266.266 33.295c-.522.07-1.056.105-1.598.105-6.644 0-12.03-5.386-12.03-12.03 0-4.417 2.381-8.278 5.929-10.37h-.067c-6.904 0-12.5 5.596-12.5 12.5S251.596 36 258.5 36a12.44 12.44 0 007.766-2.705z"
              fill={`url(#${id}f)`}
              fillRule="evenodd"
            />
          </g>
          <path
            clipRule="evenodd"
            d="M-3 58l37.119-.245 64.423-.426 4.6-.03 3.529-.053 8.329-.122c-1.335-.601-3.445-1.325-5.92-1.675-3.216-.457-7.054-.285-10.622 1.612a.503.503 0 00-.048-.066 10.192 10.192 0 00-1.767-1.973c-4.528-3.854-9.77-.208-10.448.294a1.509 1.509 0 00-.075.056l.015-.181c.015-.179.033-.48.04-.863a17.64 17.64 0 00-.103-2.23c-.222-1.852-.849-3.944-2.511-4.68-2.605-1.158-5.13 2.858-6.47 5.512-.614 1.223-.977 2.158-.977 2.158s0-.453-.13-1.166C75.55 51.496 71.985 42 62.499 42c-9.485 0-11.802 8.37-15.264 14.873l-4.777-1.5-.198-.06c-4.828-1.385-13.88.717-13.88.717s-1.72-2.522-6.613-2.829c-4.894-.31-11.933 3.923-11.933 3.923C3.133 56.622-3 58-3 58z"
            fill="#fff"
            fillRule="evenodd"
            opacity="0.5"
            style={{ mixBlendMode: "soft-light" }}
          />
        </g>
        <path
          d="M113.041 26.484c-.379-1.516-2.047-4.378-5.686-3.696-4.548.853-3.837 5.117 0 4.407 3.07-.569 1.28-1.962 0-2.587m6.216-2.032h-11.397m25.629-9.056c-2.936-2.639-9.063-8.426-10.084-10.468m3.278 3.936v3.658m3.442-.11v3.659"
          stroke="#fff"
          strokeWidth="1.126"
        />
        <path
          d="M117.316 6.19c-1.279 10.346-6.829 22.716-9.445 27.608h38.94l-6.102-9.154C126.993 17.32 119.398 9.29 117.316 6.19z"
          fill="#DAA1B5"
        />
        <path
          d="M98.604 77.56c4.25-4.625 1.783-23.61 1.783-23.61l23.713-5.451 2.872 29.06H98.604z"
          fill="#4D0D54"
        />
        <path
          d="M113.768 28.599c1.593-4.03 3.631-14.173 4.451-18.741l20.263 39.473s-23.315 6.175-22.715 4.576c0-15.784-1.999-25.308-1.999-25.308z"
          fill={`url(#${id}g)`}
        />
        <path
          d="M120.15 22.818l1.303 12.296h-2.25l-1.414-12.56a.927.927 0 01.921-1.031c.741 0 1.362.559 1.44 1.295z"
          fill={`url(#${id}h)`}
        />
        <path
          d="M160.882 26.484c.379-1.516 2.046-4.378 5.685-3.696 4.548.853 3.837 5.117 0 4.407-3.07-.569-1.279-1.962 0-2.587m-6.215-2.032h11.397"
          stroke="#fff"
          strokeWidth="1.126"
        />
        <path
          clipRule="evenodd"
          d="M120.108 35.114l-1.147-9.464h-.822l-.064-.563h.818l-.428-3.53a.925.925 0 01.247-.034c.109 0 .217.012.32.036l.428 3.528h.932l.059.563h-.923l1.147 9.464h-.567z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M142.895 9.568c2.17-.774 11.438-5.085 12.034-5.756v3.23m-9.434 1.512v2.407m3.167-3.973v2.77"
          stroke="#fff"
          strokeWidth="1.126"
        />
        <path
          clipRule="evenodd"
          d="M130.898 33.798c-5.774-6.35-10.694-15.303-13.587-27.55l.007-.057c2.082 3.1 9.677 11.13 23.393 18.453l6.103 9.154h-15.916z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M154.923 6.772c-3.279 1.968-7.598 3.473-9.511 4.098l-10.073 20.966h29.473c-4.497-7.121-8.288-19.598-9.889-25.064z"
          fill="#DAA1B5"
        />
        <path
          d="M107.461 37.7h22.014l-5.735 18.085H93.786c6.352-3.646 11.764-13.576 13.675-18.086z"
          fill="#A36281"
        />
        <path d="M151.896 5.515v2.77" stroke="#fff" strokeWidth="1.126" />
        <path
          d="M178.067 77.56c-4.25-4.625-1.783-23.61-1.783-23.61l-23.713-5.451-2.873 29.06h28.369z"
          fill="#4D0D54"
        />
        <path
          d="M158.975 23.366c-2.249-4.78-4.138-11.987-4.802-14.993L137.892 39.06s26.317 14.469 22.637 11.272c-3.68-3.197-1.554-26.967-1.554-26.967z"
          fill={`url(#${id}i)`}
        />
        <path
          d="M153.988 22.818l-1.303 12.296h2.25l1.414-12.56a.927.927 0 00-.921-1.031c-.741 0-1.362.559-1.44 1.295z"
          fill={`url(#${id}j)`}
        />
        <path
          clipRule="evenodd"
          d="M154.028 35.114l1.147-9.464h.824l.064-.563h-.82l.428-3.531a.932.932 0 00-.245-.033c-.11 0-.219.013-.323.036l-.427 3.528h-.93l-.06.563h.922l-1.148 9.464h.568z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M154.903 6.684c-3.277 1.955-10.042 4.329-11.945 4.95l-7.915 20.319h13.492c2.179-6.507 4.775-17.745 6.368-25.269z"
          fill="#fff"
        />
        <path
          d="M169.208 37.7h-15.539l5.735 18.085h23.479C176.531 52.14 171.12 42.21 169.208 37.7z"
          fill="#CE9FB6"
        />
        <path
          d="M128.512 34.809l-1.866-38.33 2.921-3.165 13.388.812v40.683l-11.359 1.46-3.084-1.46z"
          fill={`url(#${id}k)`}
        />
        <path
          d="M138.709 16.93h-1.629l-.539-13.2a10.737 10.737 0 011.126-5.244l.18.428c.569 1.353.862 2.805.862 4.272V16.93z"
          fill={`url(#${id}l)`}
        />
        <path
          d="M161.375 54.164c-11.463-10.816-18.701-24.552-20.887-30.068l3.055-4.91s7.516 16.828 24.189 34.978h-6.357z"
          fill="#A36281"
        />
        <path
          d="M131.352-6.577l-1.785-.109-2.921 3.165 1.866 38.33 4.542 2.205-1.702-43.591z"
          fill="#4D0D54"
        />
        <path
          d="M133.931 31.26c-7.265 15.337-14.462 20.988-17.153 21.896 0 0 2.637 19.72 0 28.612h47.823c-2.981-5.967-1.75-28.612-1.75-28.612-12.42-13.249-15.635-20.92-20.444-29.564-2.422 3.148-6.66 6.424-8.476 7.668z"
          fill={`url(#${id}m)`}
        />
        <circle cx="146.339" cy="48.343" fill="#4D0D54" r="4.338" />
        <path
          d="M142.742 63.07v18.678h7.934V63.07a3.967 3.967 0 10-7.934 0z"
          fill={`url(#${id}n)`}
        />
        <path
          clipRule="evenodd"
          d="M130.134 81.768V50.377l-10.639 1.19c-1.132.861-2.059 1.367-2.717 1.589 0 0 2.637 19.72 0 28.612h13.356z"
          fill={`url(#${id}o)`}
          fillRule="evenodd"
        />
        <path
          d="M138.139 61.421l.451 9.56h-3.594l-.705-9.923a1.636 1.636 0 011.631-1.751 2.22 2.22 0 012.217 2.114z"
          fill={`url(#${id}p)`}
        />
        <path
          d="M136.13 59.307l.789 11.63m-2.311-5.185h3.7"
          stroke="#fff"
          strokeWidth="1.126"
        />
        <path
          d="M155.383 61.42l-.451 9.56h3.593l.705-9.923a1.634 1.634 0 00-1.631-1.75 2.22 2.22 0 00-2.216 2.114z"
          fill={`url(#${id}q)`}
        />
        <path
          d="M157.39 59.306l-.789 11.631m2.312-5.185h-3.699"
          stroke="#fff"
          strokeWidth="1.126"
        />
        <path
          d="M166.576 61.421l-.451 9.56h3.593l.705-9.923a1.635 1.635 0 00-1.631-1.751c-1.185 0-2.16.93-2.216 2.114zm-53.239-.001l.452 9.56h-3.594l-.705-9.923a1.635 1.635 0 011.631-1.75c1.185 0 2.16.93 2.216 2.114z"
          fill="#4D0D54"
        />
        <path
          d="M127.069 53.56c9.767-8.315 15.034-26.403 16.447-34.408l-16.447 4.238s-7.579 23.001-20.957 31.178l20.957-1.009z"
          fill="#fff"
        />
        <path
          d="M154.359 4.448l.557 2.825.514-2.825-.514-7.491-.557 7.491z"
          fill={`url(#${id}r)`}
        />
        <path
          d="M116.773 3.947l.556 2.825.514-2.825-.514-7.492-.556 7.492z"
          fill={`url(#${id}s)`}
        />
        <path
          d="M137.614-1.349l.282 18.28m-1.36-12.551h2.173m-1.884 7.007h1.888"
          stroke="#fff"
          strokeWidth="0.563"
        />
        <path
          d="M169.525 65.723l-1.01 9.495m3.457-9.234l-1.011 9.495m3.456-9.235l-1.011 9.495m3.458-9.235L175.853 76m3.059-5.471l-.61 5.73m3.318-7.924l-.872 8.185m3.318-7.925l-.871 8.186m3.318-7.925l-.871 8.185m-17.157-9.639l9.357.996m-2.753 5.214l11.76 1.252m-77.99-12.809l1.45 13.624m-4.96-13.251l1.45 13.625m-4.961-13.251l1.451 13.624m-4.963-13.25l1.45 13.624m-4.384-7.85l.875 8.224m-4.761-11.372l1.25 11.745m-4.762-11.371l1.25 11.745m-4.76-11.371l1.25 11.745m24.618-13.831l-13.426 1.43m3.949 7.481L84.001 75.17"
          stroke="#FFEDED"
          strokeWidth="1.067"
        />
        <ellipse
          cx="189.915"
          cy="43.365"
          fill="#4D0D54"
          rx="0.988"
          ry="1.309"
          transform="rotate(24.772 189.915 43.365)"
        />
        <ellipse
          cx="191.033"
          cy="42.385"
          fill="#4D0D54"
          rx="0.223"
          ry="0.49"
          transform="rotate(39.77 191.033 42.385)"
        />
        <ellipse
          cx="0.223"
          cy="0.49"
          fill="#4D0D54"
          rx="0.223"
          ry="0.49"
          transform="scale(-1 1) rotate(-9.774 147.167 1133.148)"
        />
        <path
          d="M196.642 42.82c-3.192-.996-5.326.138-6.045.894-.03.031-.034.079-.052.118l-.16.343c-.042.09-.07.23.029.235h.008c.817-.026 1.668.536 1.979.881.055.061.166.037.191-.042.343-1.118 1.366-1.04 1.938-.824a.102.102 0 00.131-.06c.334-.88 1.239-1.222 1.951-1.32.106-.015.132-.194.03-.225zm-10.678-4.927c2.829 1.782 3.351 4.142 3.242 5.18-.004.042-.038.077-.056.116l-.157.344c-.041.09-.13.203-.198.13a.023.023 0 01-.005-.005c-.51-.64-1.49-.921-1.954-.935-.083-.002-.136-.103-.092-.172.628-.987-.095-1.715-.631-2.01a.103.103 0 01-.04-.138c.453-.825.127-1.736-.261-2.342-.057-.09.062-.225.152-.168z"
          fill="#4D0D54"
        />
        <ellipse
          cx="89.385"
          cy="14.467"
          fill="#4D0D54"
          rx="1.264"
          ry="1.675"
          transform="rotate(-12.305 89.385 14.467)"
        />
        <ellipse
          cx="89.773"
          cy="12.603"
          fill="#4D0D54"
          rx="0.285"
          ry="0.627"
          transform="rotate(2.693 89.773 12.603)"
        />
        <ellipse
          cx="0.285"
          cy="0.627"
          fill="#4D0D54"
          rx="0.285"
          ry="0.627"
          transform="scale(-1 1) rotate(27.302 -69.322 -175.503)"
        />
        <path
          d="M95.837 8.717c-4.03 1.447-5.333 4.253-5.485 5.58-.006.054.027.106.039.16l.11.516c.02.097.069.22.165.194a.126.126 0 00.046-.024c.813-.658 2.117-.74 2.7-.628.104.02.199-.091.163-.19-.512-1.407.592-2.118 1.344-2.338a.13.13 0 00.088-.161c-.338-1.157.321-2.205.973-2.856.097-.096-.015-.299-.143-.253zm-14.709 3.209c4.266-.363 6.62 1.645 7.31 2.788.028.047.02.108.032.162l.115.515c.021.097.029.229-.07.245a.127.127 0 01-.051-.002c-1.014-.26-2.233.208-2.717.553-.086.061-.219 0-.227-.105-.12-1.493-1.42-1.679-2.195-1.566a.13.13 0 01-.147-.11c-.175-1.193-1.211-1.87-2.075-2.19-.128-.048-.11-.279.025-.29z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M72.003 77.11l-1.356 4.95h3.72l.399-4.95-.3-7.463 2.885-3.724 5.348-4.136.725-3.816h-.42l-1.112 3.584-5.879 4.03-.82 1.742-1.225.325-.798-3.158 3.956-7.382-.209-2.369 3.975-2.044 3.168-5.08-.21-.208-3.167 4.84-3.838 1.674-.481-5.457-6.24-3.445-.302.203 5.661 3.536.649 7.956-3.627 6.213-3.095-.378-5.287-3.84h.138l-.69-1.925-7.895-7.117-.326.095 7.335 7.022.463 1.89-5.466 1.576v.53l6.129-1.246 8.192 7.376v10.195z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M138.5 74C10.094 74-94 118.772-94 174h465c0-55.228-104.094-100-232.5-100z"
          fill="#2B2C3F"
        />
        <g fill="#fff" filter={`url(#${id}t)`}>
          <path
            clipRule="evenodd"
            d="M101.157 89.501a4.97 4.97 0 019.826 0L112.126 97c.158 1.037-1.053 1.718-1.857 1.044l-.46-.386a.656.656 0 00-1.002.199l-.082.158a1.214 1.214 0 01-2.129.04.607.607 0 00-1.053 0 1.213 1.213 0 01-2.128-.04l-.083-.158a.656.656 0 00-1.002-.199l-.459.386c-.805.674-2.015-.007-1.857-1.044l1.143-7.499zm4.374.539c0 .773-.553 1.4-1.235 1.4-.683 0-1.236-.627-1.236-1.4 0-.773.553-1.4 1.236-1.4.682 0 1.235.627 1.235 1.4zm2.314 1.4c.683 0 1.236-.627 1.236-1.4 0-.773-.553-1.4-1.236-1.4-.682 0-1.235.627-1.235 1.4 0 .773.553 1.4 1.235 1.4z"
            fillRule="evenodd"
          />
          <path d="M131.673 86.832V98h-2.24v-4.752h-4.784V98h-2.24V86.832h2.24v4.592h4.784v-4.592h2.24zm1.628 6.704c0-.896.176-1.69.528-2.384.363-.693.848-1.227 1.456-1.6a3.92 3.92 0 012.064-.56c.662 0 1.238.133 1.728.4a3.49 3.49 0 011.2 1.008v-1.264h2.256V98h-2.256v-1.296c-.288.416-.688.763-1.2 1.04-.501.267-1.082.4-1.744.4a3.81 3.81 0 01-2.048-.576c-.608-.384-1.093-.923-1.456-1.616-.352-.704-.528-1.51-.528-2.416zm6.976.032c0-.544-.106-1.008-.32-1.392a2.185 2.185 0 00-.864-.896 2.264 2.264 0 00-1.168-.32c-.416 0-.8.101-1.152.304-.352.203-.64.501-.864.896-.213.384-.32.843-.32 1.376 0 .533.107 1.003.32 1.408.224.395.512.699.864.912.363.213.747.32 1.152.32a2.35 2.35 0 001.168-.304 2.32 2.32 0 00.864-.896c.214-.395.32-.864.32-1.408zm12.812-4.432V98h-2.256v-1.12a3.007 3.007 0 01-1.136.912 3.52 3.52 0 01-1.504.32c-.693 0-1.306-.144-1.84-.432a3.223 3.223 0 01-1.264-1.296c-.298-.576-.448-1.259-.448-2.048v-5.2h2.24v4.88c0 .704.176 1.248.528 1.632.352.373.832.56 1.44.56.619 0 1.104-.187 1.456-.56.352-.384.528-.928.528-1.632v-4.88h2.256zm7.122-.128c1.056 0 1.91.336 2.56 1.008.651.661.976 1.59.976 2.784V98h-2.24v-4.896c0-.704-.176-1.243-.528-1.616-.352-.384-.832-.576-1.44-.576-.618 0-1.109.192-1.472.576-.352.373-.528.912-.528 1.616V98h-2.24v-8.864h2.24v1.104a3.045 3.045 0 011.136-.896c.47-.224.982-.336 1.536-.336zm8.274 1.968v4.288c0 .299.07.517.208.656.15.128.395.192.736.192h1.04V98h-1.408c-1.888 0-2.832-.917-2.832-2.752v-4.272h-1.056v-1.84h1.056v-2.192h2.256v2.192h1.984v1.84h-1.984zm6.988 7.168c-.726 0-1.376-.128-1.952-.384-.576-.267-1.035-.624-1.376-1.072a2.725 2.725 0 01-.544-1.488h2.256c.042.341.208.624.496.848.298.224.666.336 1.104.336.426 0 .757-.085.992-.256.245-.17.368-.39.368-.656 0-.288-.15-.501-.448-.64-.288-.15-.752-.31-1.392-.48a12.195 12.195 0 01-1.632-.496 2.898 2.898 0 01-1.088-.784c-.299-.352-.448-.827-.448-1.424 0-.49.138-.939.416-1.344.288-.405.693-.725 1.216-.96.533-.235 1.157-.352 1.872-.352 1.056 0 1.898.267 2.528.8.629.523.976 1.232 1.04 2.128h-2.144a1.127 1.127 0 00-.448-.832c-.256-.213-.603-.32-1.04-.32-.406 0-.72.075-.944.224a.718.718 0 00-.32.624c0 .299.149.528.448.688.298.15.762.304 1.392.464.64.16 1.168.325 1.584.496.416.17.773.437 1.072.8.309.352.469.821.48 1.408 0 .512-.144.97-.432 1.376-.278.405-.683.725-1.216.96-.523.224-1.136.336-1.84.336z" />
        </g>
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}f`}
          x1="256.133"
          x2="256.133"
          y1="-10.817"
          y2="36"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}g`}
          x1="128.937"
          x2="115.238"
          y1="76.606"
          y2="12.172"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}h`}
          x1="119.618"
          x2="119.618"
          y1="21.523"
          y2="35.114"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}i`}
          x1="152.003"
          x2="138.542"
          y1="72.271"
          y2="10.746"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}j`}
          x1="154.52"
          x2="154.52"
          y1="21.523"
          y2="35.114"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}k`}
          x1="136.656"
          x2="118.081"
          y1="58.016"
          y2="-1.464"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}l`}
          x1="137.621"
          x2="137.621"
          y1="-1.514"
          y2="16.93"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}m`}
          x1="146.132"
          x2="133.638"
          y1="111.221"
          y2="24.609"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}n`}
          x1="146.709"
          x2="146.709"
          y1="64.31"
          y2="87.848"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}o`}
          x1="124.976"
          x2="112.638"
          y1="97.66"
          y2="53.391"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}p`}
          x1="136.439"
          x2="136.439"
          y1="59.307"
          y2="70.981"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}q`}
          x1="157.083"
          x2="157.083"
          y1="59.306"
          y2="70.98"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}r`}
          x1="155.016"
          x2="147.246"
          y1="12.496"
          y2="5.699"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}s`}
          x1="117.43"
          x2="109.66"
          y1="11.995"
          y2="5.198"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="556.136"
          id={`${id}c`}
          width="556.183"
          x="-242.931"
          y="-207.712"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_10299_107336"
            stdDeviation="78.356"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="624.443"
          id={`${id}d`}
          width="624.49"
          x="-63.26"
          y="-241.866"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_10299_107336"
            stdDeviation="95.433"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="89"
          id={`${id}e`}
          width="84.267"
          x="214"
          y="-21"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="16" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.682208 0 0 0 0 0.395833 0 0 0 0.93 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10299_107336"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_10299_107336"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="64"
          id={`${id}t`}
          width="121"
          x="79"
          y="60"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10299_107336"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_10299_107336"
            result="shape"
          />
        </filter>
        <clipPath id={`${id}a`}>
          <rect fill="#fff" height="110" rx="10" width="277" />
        </clipPath>
        <clipPath id={`${id}b`}>
          <path d="M-28 0h335v141H-28z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
